import { render, staticRenderFns } from "./DeparturesTableAlt.vue?vue&type=template&id=136e530a&scoped=true&"
import script from "./DeparturesTableAlt.vue?vue&type=script&lang=js&"
export * from "./DeparturesTableAlt.vue?vue&type=script&lang=js&"
import style0 from "./DeparturesTableAlt.vue?vue&type=style&index=0&id=136e530a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136e530a",
  null
  
)

export default component.exports